import Store from 'store/store';
import { openSidePanel, closeSidePanel } from 'store/bolt/sidePanelLoader';

Store.on('PRESSKIT_SHOW', (animate, queryString, pageId) => openSidePanel(animate, 'pressKit', false, queryString, pageId));

Store.on('PRESSKIT_HIDE', (animate, updateActivePage = true) => closeSidePanel(animate, updateActivePage, 'pressKit'));

Store.on('CLOSE_ALL_OVERLAYS', (options = {}) => {
	Store.emit('PRESSKIT_HIDE', options.animate, false);
});